var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadmapLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 1763,
    viewBox: "0 0 273 1763",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0015 12C26.0015 128 136.776 192.796 207.001 186.5C279.501 180 271.001 125 246.001 145C196.177 184.86 156.5 425 72.5006 421.5C-3.66491 418.326 5.00062 359.5 37.5006 383.5C58.0006 398.638 84.0417 454.75 133.128 482.5C191.501 515.5 288.502 510.5 262.002 488.5C218.802 452.636 121.498 771.5 40.5009 771.5C3.50086 771.5 4.50102 732 32.5009 732C77.8441 732 167.455 871.964 248.002 851C284.502 841.5 259.501 797 239.501 821C208.033 858.762 176.001 1051.5 99.5015 1085.5C32.5009 1115.28 -6.25134 1073.5 14.8751 1051.5C55.221 1009.49 82.5015 1227 193.501 1227C240.031 1227 288.375 1192.5 256.502 1185C194.728 1170.46 158.501 1451.5 60.5006 1440C-5.87384 1432.21 34.3743 1374.5 55.3743 1403.5C76.3743 1432.5 146.001 1642 226.001 1631.5C306.001 1621 235.015 1553.45 212.001 1615C170.501 1726 129.002 1764 32.0016 1755",
    stroke: "#343562",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 144.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 384.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 496.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 748.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 834.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 1063.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 1187.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 1401.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 1598.5,
    r: 9.5,
    fill: "#FFBB0B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 1753.5,
    r: 9.5,
    fill: "#FFBB0B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapLine);
export default __webpack_public_path__ + "static/media/roadmap_line.fed7f050.svg";
export { ForwardRef as ReactComponent };